/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

export interface AuthenticateCarrierContractRequest {
  form_input: FormInput;
  schema_id: string;
}

export interface AuthenticateCarrierContractResponse {
  form_output?: FormOutput;
}

export interface CarrierContract {
  carrier_configuration_data?: string;
  carrier_name?: string;
  carrier_products?: CarrierProduct[];
  contract_id?: string;
  /** Creation time, returned in RFC3339 format. Example `2018-09-08T22:47:31Z` */
  created_at?: string;
  description?: string;
  ingrid_products?: IngridProduct[];
  name?: string;
  /** key will include information like product tag (similar to what we have in service configuration right now) */
  schema_id?: string;
  site_id?: string;
  /** Last modification time, returned in RFC3339 format. Example `2018-09-08T22:47:31Z` */
  updated_at?: string;
}

export interface CarrierContractsUpdateCarrierContractBody {
  carrier_configuration_data?: string;
  description?: string;
  name?: string;
  update_mask: string;
}

export interface CarrierProduct {
  product_name?: string;
  required_booking_schema_id?: string;
  shipping_method?: string;
}

export interface ContractSchema {
  carrier_name?: string;
  carrier_products?: CarrierProduct[];
  ingrid_products?: IngridProduct[];
  schema_id?: string;
}

export interface CreateCarrierContractRequest {
  carrier_configuration_data: string;
  description?: string;
  name: string;
  schema_id?: string;
}

export interface CreateCarrierContractResponse {
  carrier_contract?: CarrierContract;
}

export interface FindContractSchemaResponse {
  /** authentication_form_json_schema = 3; defines the schema for the authentication form. Will always be json. Optional. */
  authentication_form_json_schema?: string;
  /** authentication_form_ui_schema defines HOW the authentication form should be displayed. Will always be json. Optional. */
  authentication_form_ui_schema?: string;
  /** json_schema defines WHAT should be displayed. Will always be json. Required. */
  json_schema?: string;
  /** ui_schema defines HOW the schema should be displayed. Will always be json. Optional. */
  ui_schema?: string;
}

export interface FormInput {
  /** StepInput represents the input data for a particular form step in a process. */
  step_input?: StepInput;
}

export interface FormOutput {
  /** The data returned when the form finishes the flow. */
  data?: string;
  is_flow_completed?: boolean;
  /** StepOutput represents the output data from a particular form step in a process. */
  step_output?: StepOutput;
}

export interface GetCarrierContractResponse {
  carrier_contract?: CarrierContract;
}

export interface GetCarrierProductsResponse {
  carrier_products?: CarrierProduct[];
}

export interface GetContractSchemaResponse {
  /** authentication_form_json_schema = 3; defines the schema for the authentication form. Will always be json. Optional. */
  authentication_form_json_schema?: string;
  /** authentication_form_ui_schema defines HOW the authentication form should be displayed. Will always be json. Optional. */
  authentication_form_ui_schema?: string;
  /** json_schema defines WHAT should be displayed. Will always be json. Required. */
  json_schema?: string;
  /** ui_schema defines HOW the schema should be displayed. Will always be json. Optional. */
  ui_schema?: string;
}

/** @default "INGRID_PRODUCT_UNKNOWN" */
export type IngridProduct =
  | "INGRID_PRODUCT_UNKNOWN"
  | "INGRID_PRODUCT_CHECKOUT"
  | "INGRID_PRODUCT_BOOKING"
  | "INGRID_PRODUCT_TRACKING_POLLING"
  | "INGRID_PRODUCT_TRACKING_FTP"
  | "INGRID_PRODUCT_TRACKING_PUSHING";

export interface ListCarrierContractsResponse {
  carrier_contracts?: CarrierContract[];
}

export interface ListSchemasResponse {
  contract_schemas?: ContractSchema[];
}

export interface Status {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

/** StepInput represents the input data for a particular form step in a process. */
export interface StepInput {
  /** The data associated with the current form step. */
  data?: string;
  /**
   * The number representing the current form step.
   * @format int32
   */
  number?: number;
}

/** StepOutput represents the output data from a particular form step in a process. */
export interface StepOutput {
  /** A description of the next form step or the form process. */
  description?: string;
  /** An error message, if any errors occurred during the form process. */
  error_message?: string;
  /** A generic message that could include warnings, informational content, or status. */
  message?: string;
  /**
   * The number representing the next step in the form process.
   * @format int32
   */
  next_step_number?: number;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/carrier_contracts" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title carrier_contracts API
 * @version 1.0
 * @baseUrl /v1/carrier_contracts
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  authenticate = {
    /**
     * No description
     *
     * @name CarrierContractsAuthenticateCarrierContract
     * @request POST:/authenticate
     * @secure
     */
    carrierContractsAuthenticateCarrierContract: (
      body: AuthenticateCarrierContractRequest,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateCarrierContractResponse, Status>({
        path: `/authenticate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  carrierProducts = {
    /**
     * No description
     *
     * @name CarrierContractsGetCarrierProducts
     * @request GET:/carrier_products
     * @secure
     */
    carrierContractsGetCarrierProducts: (params: RequestParams = {}) =>
      this.request<GetCarrierProductsResponse, Status>({
        path: `/carrier_products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contracts = {
    /**
     * No description
     *
     * @name CarrierContractsListCarrierContracts
     * @request GET:/contracts
     * @secure
     */
    carrierContractsListCarrierContracts: (
      query?: {
        shipping_method?: string;
        ingrid_products?: (
          | "INGRID_PRODUCT_UNKNOWN"
          | "INGRID_PRODUCT_CHECKOUT"
          | "INGRID_PRODUCT_BOOKING"
          | "INGRID_PRODUCT_TRACKING_POLLING"
          | "INGRID_PRODUCT_TRACKING_FTP"
          | "INGRID_PRODUCT_TRACKING_PUSHING"
        )[];
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListCarrierContractsResponse, Status>({
        path: `/contracts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CarrierContractsCreateCarrierContract
     * @request POST:/contracts
     * @secure
     */
    carrierContractsCreateCarrierContract: (body: CreateCarrierContractRequest, params: RequestParams = {}) =>
      this.request<CreateCarrierContractResponse, Status>({
        path: `/contracts`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CarrierContractsGetCarrierContract
     * @request GET:/contracts/{contract_id}
     * @secure
     */
    carrierContractsGetCarrierContract: (
      contractId: string,
      query?: {
        shipping_method?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCarrierContractResponse, Status>({
        path: `/contracts/${contractId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CarrierContractsDeleteCarrierContract
     * @request DELETE:/contracts/{contract_id}
     * @secure
     */
    carrierContractsDeleteCarrierContract: (contractId: string, params: RequestParams = {}) =>
      this.request<object, Status>({
        path: `/contracts/${contractId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CarrierContractsUpdateCarrierContract
     * @request PATCH:/contracts/{contract_id}
     * @secure
     */
    carrierContractsUpdateCarrierContract: (
      contractId: string,
      body: CarrierContractsUpdateCarrierContractBody,
      params: RequestParams = {},
    ) =>
      this.request<object, Status>({
        path: `/contracts/${contractId}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  schemas = {
    /**
     * No description
     *
     * @name CarrierContractsListSchemas
     * @request GET:/schemas
     * @secure
     */
    carrierContractsListSchemas: (
      query?: {
        ingrid_products?: (
          | "INGRID_PRODUCT_UNKNOWN"
          | "INGRID_PRODUCT_CHECKOUT"
          | "INGRID_PRODUCT_BOOKING"
          | "INGRID_PRODUCT_TRACKING_POLLING"
          | "INGRID_PRODUCT_TRACKING_FTP"
          | "INGRID_PRODUCT_TRACKING_PUSHING"
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ListSchemasResponse, Status>({
        path: `/schemas`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CarrierContractsGetContractSchema
     * @request GET:/schemas/{schema_id}
     * @secure
     */
    carrierContractsGetContractSchema: (schemaId: string, params: RequestParams = {}) =>
      this.request<GetContractSchemaResponse, Status>({
        path: `/schemas/${schemaId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  schemasFind = {
    /**
     * No description
     *
     * @name CarrierContractsFindContractSchema
     * @request GET:/schemas.find
     * @secure
     */
    carrierContractsFindContractSchema: (
      query: {
        shipping_method: string;
        ingrid_products: (
          | "INGRID_PRODUCT_UNKNOWN"
          | "INGRID_PRODUCT_CHECKOUT"
          | "INGRID_PRODUCT_BOOKING"
          | "INGRID_PRODUCT_TRACKING_POLLING"
          | "INGRID_PRODUCT_TRACKING_FTP"
          | "INGRID_PRODUCT_TRACKING_PUSHING"
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FindContractSchemaResponse, Status>({
        path: `/schemas.find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
